var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.079,19.983h33.935 c3.377,0,6.143,2.765,6.143,6.144v32.748c0,3.379-2.766,6.143-6.143,6.143H32.079"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.299,
    y1: 42.246,
    x2: 37.26,
    y2: 42.246
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.299,
    y1: 49.932,
    x2: 37.26,
    y2: 49.932
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.299,
    y1: 57.617,
    x2: 37.26,
    y2: 57.617
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 64.066,
    y1: 42.246,
    x2: 58.029,
    y2: 42.246
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 64.066,
    y1: 49.932,
    x2: 58.029,
    y2: 49.932
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 64.066,
    y1: 57.617,
    x2: 58.029,
    y2: 57.617
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 53.682,
    y1: 42.246,
    x2: 47.645,
    y2: 42.246
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 53.682,
    y1: 49.932,
    x2: 47.645,
    y2: 49.932
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 53.682,
    y1: 57.617,
    x2: 47.645,
    y2: 57.617
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 38.633,
    y: 27.384,
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 24.061,
    height: 7.243
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    d: "M21.011,19.407c-4.461,0-8.166,3.762-8.166,8.359 v29.468c0,4.598,3.705,8.359,8.166,8.359s8.166-3.762,8.166-8.359V27.766C29.177,23.168,25.472,19.407,21.011,19.407z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.62dbf2d6dfbd1882638bb6f6ddf92e9d.svg";
export { ForwardRef as ReactComponent };